import { Chip } from "@mui/material";
import { ForecastType, FORECAST_TYPE_LABELS } from "../../models/general/forecast";

interface ForecastTypeBadgeProps {
  type?: ForecastType | null;
}

const ForecastTypeBadge = ({ type }: ForecastTypeBadgeProps) => {
  if (!type) return null;

  return (
    <Chip
      size="small"
      label={FORECAST_TYPE_LABELS[type]}
      color={type === ForecastType.NET ? "secondary" : "primary"}
      variant="outlined"
      aria-label={FORECAST_TYPE_LABELS[type]}
    />
  );
};

export default ForecastTypeBadge;
